module.exports = __webpack_public_path__ + "static/media/kid-sprinkling-on-cupcake.1f3604a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-sprinkling-on-cupcake.jpg
// module id = 810
// module chunks = 0